export default __webpack_public_path__ + "static/4-42c6f4d2e697031a16464a226749d141.jpg";